<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="50%"
      title="安装完成"
      :close-on-click-modal="false"
    >
    <h3>
        提交前请确保设备的分成规则已设置，若未设置将返现失败。
    </h3>
      <el-form :model="form" label-width="auto" :rules="rules" ref="mapForm">
        <el-form-item label="安装人" prop="name">
          <el-input v-model="form.name" placeholder="安装人"></el-input>
        </el-form-item>
         <el-form-item label="安装人联系方式">
          <el-input v-model="form.phone" placeholder="联系电话"></el-input>
        </el-form-item>
        <el-form-item label="安装说明">
          <el-input v-model="form.remark" placeholder="安装说明"></el-input>
        </el-form-item>
         <el-form-item label="安装图片" required>
           <images-uploader
                ref="imgs"
                @getImgUrl="v=>form.pic = v"
              >
              </images-uploader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { install_rules } from "../rule";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      form: {},
      temp: {},
      rules: install_rules,
      addServiceDialog: false,
      device: {},
      manager: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },

  methods: {
    open(row) {
      this.device = row;
      this.form = {}
      this.addServiceDialog = true;
    },

    submitForm() {
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/user/deviceInstallRecord/insert";
      this.form.device_sn = this.device.device_sn;
      
      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "success", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
      });


    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>